module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMBAMAAACkW0HUAAAAAXNSR0IB2cksfwAAABtQTFRFAAAAGxBiGw9jGw9jGxBjIBBgGw9jGw9jGw9k0tjeVQAAAAl0Uk5TAGC//18Qz9DA+4N2yAAAAEdJREFUeJxjYGBUNnJgYGBNNjY2C2BgNwaCBAZhYwNjY0OGZhDPgsEYxDOGUc0gygKoxBikBKyhgIG12NjYPICBgbHZQoABAEIqDhivlEF9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/info.png
// module id = 304
// module chunks = 33